export default "    <router-outlet class=\"h-100\"></router-outlet>\n    <!-- <router-outlet name=\"p\"></router-outlet> -->"